// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"src-pages-Home-Slogan-index-module__wrapper--B8azg"};